var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V256H496V16Z",
    fill: "#2B4896"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 256H16V496H496V256Z",
    fill: "#E32D3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 496H18.7188L86.8438 427.648L256 257.928V256.8L16 16V496Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.9 282.429C128.496 282.429 140.329 270.596 140.329 255.999C140.329 241.403 128.496 229.57 113.9 229.57C99.3037 229.57 87.4709 241.403 87.4709 255.999C87.4709 270.596 99.3037 282.429 113.9 282.429Z",
    fill: "#FCD116"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1053 256L61.5373 259.432L113.9 256L61.5373 252.568L58.1053 256Z",
    fill: "#FCD116"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9784 262.572L66.7791 265.373L113.9 256L63.9784 262.572Z",
    fill: "#FCD116"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M234.13 256L224.198 259.452L223.984 269.964L217.632 261.586L207.568 264.63L213.574 256H234.13Z",
    fill: "#FCD116"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPh);
export default __webpack_public_path__ + "static/media/PH.b599cf3b5dc16e1def766660bf2eb40e.svg";
export { ForwardRef as ReactComponent };